module.exports = __webpack_public_path__ + "img/clusters.b8220f94.jpg";